var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgByLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3974 16.8054C14.7432 17.2677 15.1845 17.6503 15.6912 17.9272C16.1979 18.204 16.7582 18.3686 17.3342 18.4099C17.9101 18.4511 18.4882 18.368 19.0292 18.1662C19.5702 17.9644 20.0615 17.6486 20.4697 17.2402L22.8857 14.8242C23.6193 14.0647 24.0251 13.0476 24.016 11.9918C24.0068 10.936 23.5833 9.926 22.8367 9.17941C22.0901 8.43282 21.0801 8.00933 20.0243 8.00015C18.9685 7.99098 17.9514 8.39685 17.1919 9.13036L15.8067 10.5075M17.6188 15.1946C17.2729 14.7323 16.8316 14.3497 16.3249 14.0728C15.8182 13.796 15.2579 13.6314 14.6819 13.5901C14.106 13.5489 13.5279 13.632 12.9869 13.8338C12.4459 14.0356 11.9546 14.3514 11.5464 14.7598L9.13036 17.1758C8.39685 17.9353 7.99098 18.9524 8.00015 20.0082C8.00933 21.064 8.43282 22.074 9.17941 22.8206C9.926 23.5672 10.936 23.9907 11.9918 23.9998C13.0476 24.009 14.0647 23.6031 14.8242 22.8696L16.2013 21.4925",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgByLink);
export default __webpack_public_path__ + "static/media/by-link.323978c1787ca09c8b5a52826d5001c8.svg";
export { ForwardRef as ReactComponent };